export enum DefaultSearch {
  PAGE_NUMBER = 1,
  PAGE_SIZE = 30,
  SORT = 'wn_score',
  ORDER = 'DESC',
  QUERY_PARAM_KEY = 'defaultSearch'
}
